
export const containerEntregaAguardandoRecebimento = {
    background: '#ffffff',
    borderRadius: '5px',
    padding: '1px 10px',
    marginBottom: '5px',
    boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.322)'
}

export const sxGrid = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}

export const IconReceber = {
    width: '30px',
    '&:hover': { color: 'green' }
}
